<a id="btnDownload" class="d-none" href="javascript:void('');" download>DownloadFakeBtn</a>
<div class="page">
    <div class="page-padding">
        <div class="page-header-custom">
            <svg-icon src="assets/svg/child.svg"></svg-icon>
            <h1 class="page-title">{{'daycare.cargainicial'|translate}}</h1>
        </div>

        <p class="daycare-hint">{{'daycare.cargainicialexplica'|translate}}</p>
        <p class="daycare-hint text-muted"><small>⚠️ {{'daycare.previewvolatil'|translate}}</small></p>

        <!-- Passo 1: unidade + arquivo -->
        <div class="daycare-form">
            <div class="input-material" *ngIf="showUnitySelector">
                <select id="unity" [(ngModel)]="unityId" class="form-control">
                    <option [ngValue]="null" disabled>{{'daycare.selecioneunidade'|translate}}</option>
                    <option *ngFor="let u of unities" [ngValue]="u.id">{{u.name}}</option>
                </select>
                <label for="unity" class="mb-0 mr-3">{{'unidade'|translate}}</label>
            </div>

            <label class="btn btn-gray-fill mb-0">
                <svg-icon class="mr-1" src="assets/svg/downloads.svg"></svg-icon>
                <span>{{ fileName || ('daycare.selecionararquivo'|translate) }}</span>
                <input type="file" class="d-none"
                       accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                       onclick="this.value=null"
                       (change)="onFileSelected($event)"/>
            </label>

            <button type="button" class="btn btn-primary text-white" [disabled]="loading" (click)="analyze()">
                {{'daycare.analisarplanilha'|translate}}
            </button>
        </div>

        <div *ngIf="loading" class="text-center my-4">{{'daycare.processando'|translate}}</div>

        <!-- Resultado do preview -->
        <div *ngIf="preview && !loading" class="daycare-preview mt-4">

            <!-- Bloqueio: unidade já carregada -->
            <div *ngIf="preview.blocked" class="alert alert-danger">
                <strong>{{'daycare.unidadejacarregada'|translate}}</strong>
                <div><small>{{ preview.blockedReason }}</small></div>
            </div>

            <ng-container *ngIf="!preview.blocked">
                <!-- Totais do que será importado -->
                <div class="daycare-block">
                    <h5>{{'daycare.seraoimportados'|translate}}</h5>
                    <div class="daycare-totals">
                        <span><b>{{ preview.totals?.employees || 0 }}</b> {{'daycare.colaboradores'|translate}}</span>
                        <span><b>{{ preview.totals?.children || 0 }}</b> {{'daycare.criancas'|translate}}</span>
                        <span><b>{{ preview.totals?.guardians || 0 }}</b> {{'pessoasautorizadas'|translate}}</span>
                        <span class="text-muted"><b>{{ preview.totals?.guardiansWithoutDocument || 0 }}</b> {{'daycare.semdocumento'|translate}}</span>
                    </div>
                </div>

                <!-- Pendências INFO (serão importadas) -->
                <div class="daycare-block" *ngIf="pendenciesBySeverity('info').length">
                    <h5 class="text-warning">{{'daycare.pendenciasinfo'|translate}}</h5>
                    <div class="table-responsive">
                        <table class="table table_regular">
                            <thead>
                            <tr>
                                <th>{{'daycare.linha'|translate}}</th>
                                <th>{{'crianca'|translate}}</th>
                                <th>{{'re'|translate}}</th>
                                <th>{{'daycare.motivo'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let p of pendenciesBySeverity('info')">
                                <td>{{ p.row }}</td>
                                <td>{{ p.childName }}</td>
                                <td>{{ p.re }}</td>
                                <td>{{ p.reason }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Pendências ROW-SKIP (NÃO serão importadas) -->
                <div class="daycare-block daycare-danger-block" *ngIf="preview.rowsSkipped?.length">
                    <h5 class="text-danger">⚠️ {{'daycare.linhasdescartadas'|translate}}</h5>
                    <p class="text-danger"><small>{{'daycare.linhasdescartadasexplica'|translate}}</small></p>
                    <div class="table-responsive">
                        <table class="table table_regular">
                            <thead>
                            <tr>
                                <th>{{'daycare.linha'|translate}}</th>
                                <th>{{'crianca'|translate}}</th>
                                <th>{{'re'|translate}}</th>
                                <th>{{'daycare.motivo'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let r of preview.rowsSkipped" class="row-danger">
                                <td>{{ r.row }}</td>
                                <td>{{ r.childName || '—' }}</td>
                                <td>{{ r.re }}</td>
                                <td>{{ r.reason }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Confirmar -->
                <div class="text-right mt-3">
                    <button type="button" class="btn btn-primary btn-lg text-white" [disabled]="loading" (click)="confirmImport()">
                        {{'daycare.confirmarimportacao'|translate}}
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</div>
